import {useEffect, useState, useRef} from 'preact/hooks';
import classNames from 'classnames';
import _ from 'lodash';

import {handleCollapse} from '~/utils/htmlElement';
import Tooltip from '~/components/Tooltip';
import {useQfScroll, useQfScreen} from '../comp/utils/hook';
import {modelCenter} from '~/locals/qianfan/index';
import collapseArrow from '~/assets/qianfan/icon-collapse-arrow.png';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';
import {linkArrow} from '../comp/commonCom';

const id = 'modelCenter';
const moduleTitleClassName = 'qf-module-title';
const moduleDescClassName = 'qf-module-desc';
const moduleContentClassName = 'qf-module-content';
const ModelCardLinkList = props => {
    const {screenWidth} = useQfScreen();
    const {name, onlineTest, deployment, doc, applyTest, clName = 'link'} = props.data;
    return (
        <div className={clName}>
            {onlineTest && (
                <a
                    href={onlineTest}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-track-category="新官网PC-行业领先文心大模型"
                    data-track-name={name}
                    data-track-value="在线体验"
                >
                    在线体验
                    {screenWidth < 1200 && linkArrow}
                </a>
            )}
            {deployment && (
                <a
                    href={deployment}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-track-category="新官网PC-行业领先文心大模型"
                    data-track-name={name}
                    data-track-value="快速部署"
                >
                    快速部署
                    {screenWidth < 1200 && linkArrow}
                </a>
            )}
            {doc && (
                <a
                    href={doc}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-track-category="新官网PC-行业领先文心大模型"
                    data-track-name={name}
                    data-track-value="API文档"
                >
                    API文档
                    {screenWidth < 1200 && linkArrow}
                </a>
            )}
            {applyTest && (
                <a
                    href={applyTest}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-track-category="新官网PC-行业领先文心大模型"
                    data-track-name={name}
                    data-track-value="申请测试"
                >
                    申请测试
                    {screenWidth < 1200 && linkArrow}
                </a>
            )}
        </div>
    );
};

const ModelCard = props => {
    const {name, label, type, icon, tagClass, tag, deployment, onlineTest, desc, desc_m, doc, applyTest} = props.data;
    const {idx, screenWidth} = props;
    const modelLabel = _.compact([...label, type]);
    return (
        <div className={`modelcard ${idx !== 0 ? 'text-left' : 'text-center'}`} key={name}>
            {idx === 0 && <img src={icon} alt={name} />}
            <h4 className="name">{name}</h4>
            <span className={`tag ${tagClass}`}>{tag}</span>
            <div className="model-label-list">
                {modelLabel.map(value => {
                    return (
                        <span className="model-label" key={value}>
                            {value}
                        </span>
                    );
                })}
            </div>
            <p className="des no_rem_fs_16">{screenWidth > 1199 ? desc : desc_m}</p>
            {/* 这里之所以用两个组件是因为在伸缩过程中1200px以上会出现过渡效果 */}
            {screenWidth > 1199 && (
                <ModelCardLinkList data={{name, onlineTest, deployment, doc, applyTest, clName: 'link'}} />
            )}
            {screenWidth < 1200 && (
                <ModelCardLinkList data={{name, onlineTest, deployment, doc, applyTest, clName: 'link-ipad'}} />
            )}
        </div>
    );
};

const ModelCardMobile = props => {
    const {name, label, type, icon, tagClass, tag, deployment, onlineTest, desc_m, doc, applyTest} = props.data;
    const modelLabel = _.compact([...label, type]);

    const handleCollapseClick = index => {
        const collapse = document.querySelectorAll('.modelcard-mobile .collapse-arrow');
        const content = document.querySelectorAll('.modelcard-mobile .item-content');
        handleCollapse(collapse, content, index);
    };

    return (
        <div className="modelcard-mobile">
            <div className="modelcard-mobile-header" onClick={() => handleCollapseClick(props.idx)}>
                <span className="logo-icon">
                    <img src={icon} alt={name} />
                </span>
                <div className="model-info">
                    <h4 className="name">{name}</h4>
                    <div className="model-label-list">
                        {modelLabel.map(value => {
                            return (
                                <span className="model-label" key={value}>
                                    {value}
                                </span>
                            );
                        })}
                    </div>
                </div>
                <span className="collapse-arrow">
                    <img src={collapseArrow} alt="箭头" />
                </span>
            </div>
            <div className="item-content">
                <p className="des">{desc_m}</p>
                <ModelCardLinkList data={{name, onlineTest, deployment, doc, applyTest, clName: 'link-mobile'}} />
            </div>
        </div>
    );
};

const ModelCenter = () => {
    const {list, title, desc, btn} = modelCenter;
    const [cardLists, setCardLists] = useState([]);
    const [mobileCardLists, mobileSetCardLists] = useState([]);
    const {showElement, handleScroll, isMobile} = useQfScroll(id);
    const {screenWidth} = useQfScreen();
    useCptDuration(id, {
        name: `${applicationName}-${title?.split(',')?.join('')}-停留时长`
    });

    useEffect(() => {
        handleScroll();
    }, [handleScroll]);

    useEffect(() => {
        const width = screenWidth;
        if (width > 991) {
            setCardLists([[...list.slice(0, 3)], [...list.slice(3)]]);
            mobileSetCardLists([]);
        } else if (width > 767 && width < 992) {
            setCardLists([[...list.slice(0, 2)], [...list.slice(2, 4)], [...list.slice(4)]]);
            mobileSetCardLists([]);
        } else {
            setCardLists([]);
            mobileSetCardLists([...list.slice(0, 3)]);
        }
    }, [screenWidth]);

    return (
        <div className="model-center" id={id}>
            <div className="module-wrapper">
                <div className="module-container">
                    <h2 className={`title ${moduleTitleClassName}`}>
                        {title.split(',')[0]}
                        <span className="font-gradual">{title.split(',')[1]}</span>
                    </h2>
                    <p className={`module-desc no_rem_fs_16 ${moduleDescClassName}`}>{desc}</p>
                    <div className={`container-wrapper ${moduleContentClassName}`}>
                        <div className="content">
                            {/* pc端卡片 */}
                            {cardLists.map((list, index) => {
                                return (
                                    /* eslint-disable */
                                    <div className={`flex-cards ${'flex-cards' + index}`} key={index}>
                                        {list.map((item, i) => {
                                            return (
                                                <ModelCard
                                                    data={item}
                                                    idx={index + screenWidth > 1199}
                                                    key={item.name}
                                                    screenWidth={screenWidth}
                                                />
                                            );
                                        })}
                                    </div>
                                );
                            })}

                            {/* mobile端卡片 */}
                            {mobileCardLists.map((item, index) => {
                                return <ModelCardMobile data={item} idx={index} key={item.name} />;
                            })}
                            <div className="btn-wrapper">
                                {btn.map(item => {
                                    return (
                                        <a
                                            key={item.id}
                                            className={item.className}
                                            href={item.link}
                                            target="_blank"
                                            rel="noreferrer"
                                            {...item.trackInfo}
                                        >
                                            {item.text}
                                        </a>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModelCenter;
